/* AquaticMotiv reviews block (snippets/mm-am-reviews.liquid, Partners & Affiliates, Oct 28 2026).
   1. Moves the block into Judge.me's app block (same spot and panel on phones and computers) and hides Judge.me there (not removed).
   2. Loads the review data only when the block comes near the screen; 5 reviews a page, numbered pages like Judge.me. */
(function () {
  var root = document.getElementById("mm-am-reviews");
  if (!root || root.__mm) return; root.__mm = true;
  var home = root.parentElement;
  var ab = document.querySelector('.shopify-app-block[id*="judge_me_reviews"]');
  if (ab) {
    ab.classList.add("mm-amr-host"); ab.appendChild(root);
    // the block's own (now empty) wrapper takes no room; only when nothing but style/script tags is left in it
    if (home && home !== ab && ![].some.call(home.children, function (k) { return !/^(LINK|SCRIPT|STYLE)$/.test(k.tagName); })) home.style.display = "none";
  }
  root.hidden = false;

  var IMG = root.getAttribute("data-img"), PN = root.getAttribute("data-partner") || "AquaticMotiv", PER = 5;
  // photo: a Judge.me file name (AM) or a full URL (ASG: Wix / Etsy images, shown as they are)
  function pic(f, w) { return /^https?:/.test(f) ? f : IMG + f + "?quality=80&width=" + w; }
  var list = root.querySelector(".mm-amr__list"), nav = root.querySelector(".mm-amr__pages"), sortEl = root.querySelector(".mm-amr__sort");
  var all = null, view = [], cur = 1;

  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function stars(n) {
    var s = el("div", "mm-amr__rs"); s.setAttribute("role", "img"); s.setAttribute("aria-label", n + " out of 5 stars");
    for (var i = 1; i <= 5; i++) { var t = el("span", i <= n ? "is-on" : "", "\u2605"); t.setAttribute("aria-hidden", "true"); s.appendChild(t); }
    return s;
  }
  function date(d) { var p = d.split("-"); return p.length === 3 ? p[1] + "/" + p[2] + "/" + p[0] : d; }
  function has(r) { return r[7] && r[7].length; }
  // r = [date, stars, name, location, verified, title, body, [photo files], AM reply]
  function card(r) {
    var c = el("article", "mm-amr__rev"); c.appendChild(stars(r[1]));
    var who = el("div", "mm-amr__who"), nm = r[2] || "Anonymous";
    who.appendChild(el("span", "mm-amr__ini", nm.charAt(0)));
    var box = el("div"), n = el("div", "mm-amr__nm", nm);
    if (r[4]) n.appendChild(el("small", "", "Verified buyer"));
    box.appendChild(n); box.appendChild(el("span", "mm-amr__date", date(r[0]) + (r[3] ? " \u00b7 " + r[3] : "")));
    who.appendChild(box); c.appendChild(who);
    if (r[5]) c.appendChild(el("p", "mm-amr__rt", r[5]));
    if (r[6]) c.appendChild(el("p", "mm-amr__rb", r[6]));
    if (has(r)) {
      var ps = el("div", "mm-amr__pics");
      r[7].forEach(function (f, i) {
        var a = el("a"); a.href = pic(f, 1024); a.target = "_blank"; a.rel = "nofollow noopener";
        a.setAttribute("aria-label", "Review photo " + (i + 1) + " (opens full size)");
        var im = el("img"); im.src = pic(f, 160); im.alt = "Customer photo"; im.loading = "lazy"; im.decoding = "async";
        im.width = 72; im.height = 72; im.referrerPolicy = "no-referrer";
        a.appendChild(im); ps.appendChild(a);
      });
      c.appendChild(ps);
    }
    if (r[8]) { var rp = el("div", "mm-amr__reply"); rp.appendChild(el("b", "", "Reply from " + PN + ":")); rp.appendChild(document.createTextNode(r[8])); c.appendChild(rp); }
    return c;
  }
  function build() {
    var s = sortEl.value, v = all.slice();
    if (s === "pic") v = v.filter(has);
    var newer = function (a, b) { return a[0] < b[0] ? 1 : a[0] > b[0] ? -1 : 0; };
    var by = { hi: function (a, b) { return b[1] - a[1] || newer(a, b); }, lo: function (a, b) { return a[1] - b[1] || newer(a, b); },
      picfirst: function (a, b) { return (has(b) ? 1 : 0) - (has(a) ? 1 : 0) || newer(a, b); } }[s];
    if (by) v.sort(by);   // the data is already newest first
    view = v; go(1, false);
  }
  function btn(label, p, dis, curr) {
    var b = el("button", "", label); b.type = "button"; if (dis) b.disabled = true; if (curr) b.setAttribute("aria-current", "page");
    b.addEventListener("click", function () { go(p, true); }); return b;
  }
  function go(p, scroll) {
    var pages = Math.max(1, Math.ceil(view.length / PER)); cur = Math.min(Math.max(1, p), pages);
    list.textContent = "";
    if (!view.length) list.appendChild(el("p", "mm-amr__none", "No reviews match."));
    var f = document.createDocumentFragment();
    view.slice((cur - 1) * PER, cur * PER).forEach(function (r) { f.appendChild(card(r)); });
    list.appendChild(f);
    nav.textContent = ""; nav.hidden = pages < 2;
    if (pages > 1) {
      nav.appendChild(btn("\u2039", cur - 1, cur === 1)); var from = Math.max(1, cur - 2), to = Math.min(pages, from + 4); from = Math.max(1, to - 4);
      if (from > 1) { nav.appendChild(btn("1", 1)); if (from > 2) nav.appendChild(el("span", "", "\u2026")); }
      for (var i = from; i <= to; i++) nav.appendChild(btn(String(i), i, false, i === cur));
      if (to < pages) { if (to < pages - 1) nav.appendChild(el("span", "", "\u2026")); nav.appendChild(btn(String(pages), pages)); }
      nav.appendChild(btn("\u203a", cur + 1, cur === pages));
    }
    if (scroll) root.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  function load() {
    if (all) return; all = [];
    // the data file is a script (Shopify minifies .js assets, so it can't be fetched as plain JSON): it adds itself to window.mmAMR
    function done() { var d = window.mmAMR || {}, p = d[root.getAttribute("data-pid")]; all = (p && p.r) || []; build(); }
    function fail() { list.textContent = ""; list.appendChild(el("p", "mm-amr__none", "Reviews could not load. Please refresh the page.")); all = null; }
    if (window.mmAMR && window.mmAMR[root.getAttribute("data-pid")]) { done(); return; }
    var s = document.createElement("script"); s.src = root.getAttribute("data-src"); s.async = true; s.onload = done; s.onerror = fail;
    document.head.appendChild(s);
  }
  sortEl.addEventListener("change", function () { if (all && all.length) build(); });
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) { if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: "800px 0px" });
    io.observe(root);
  } else load();
  // the stars under the product name scroll down here
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("[data-mm-amr-link]"); if (!a) return;
    e.preventDefault();
    var hdr = document.querySelector("header, .header, #header-component");
    root.style.scrollMarginTop = ((hdr ? hdr.getBoundingClientRect().height : 80) + 16) + "px";
    root.scrollIntoView({ behavior: "smooth", block: "start" }); load();
  });
})();
